import CheckboxFilterGroup from './CheckboxFilterGroup';

export default CheckboxFilterGroup;
